var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/registry-quickshop/registry-quickshop-name.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12 o-extra-large--10 c-registry-quickshop__name\">\n\n\t\t<p class=\" c-registry-quickshop__name--p ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isEgiftCard") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "innerProduct")),"isGiftCard")) {
output += " c-registry-quickshop__name--giftcard ";
;
}
output += "\">\n\n\t\t    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"registry")),"event")),"name"), env.opts.autoescape);
output += "\n\n\t\t</p>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/registry-quickshop/registry-quickshop-name.j2"] , dependencies)